angular.module('access.Nodes')
    .factory('NodeWithLinks', ['$resource', 'NodeWithLinksInterceptor',
        function ($resource, NodeWithLinksInterceptor) {
            var resource = $resource('/sync_and_share_nodes/with_links', {}, {
                query: {
                    method: 'GET',
                    params: { per_page: 50 },
                    isArray: true,
                    cancellable: true,
                    interceptor: NodeWithLinksInterceptor
                }
            });

            resource.search = resource.query;

            return resource;
        }]);
